import React, { useEffect, useState } from "react";
import LogoTurismo from "../../assets/logoTurismo";
import ModalReservaTour from "../common/modal/ModalReservaTour";

export default function ReservarTour() {
    const [activeIndex, setActiveIndex] = useState(0);
    const images = [
        `${process.env.PUBLIC_URL}/images/reserva-1.png`,
        `${process.env.PUBLIC_URL}/images/reserva-2.png`,
        `${process.env.PUBLIC_URL}/images/reserva-3.png`
    ];
    const [formData, setFormData] = useState({
        fullName: '',
        phone: '',
        email: '',
        package: '',
        numberOfPeople: 1,
        tourDate: '',
        tourTime: '',
        paymentMethod: '',
    });
    const [showModal, setShowModal] = useState(false);
    const [data,setData]=useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault(); // Evita que la página se recargue
        setShowModal(true);
        console.log(formData);
        setData(formData);
    };

    const handleIsCloseModal = () => {
        setShowModal(false);
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [images.length]);

    const handlePrev = () => {
        const newIndex = activeIndex === 0 ? images.length - 1 : activeIndex - 1;
        setActiveIndex(newIndex);
    };

    const handleNext = () => {
        const newIndex = activeIndex === images.length - 1 ? 0 : activeIndex + 1;
        setActiveIndex(newIndex);
    };

    return (
        <>
            <header className="o_footer_container">
                <nav className="o_navbar_container">
                    <div className="flex items-start justify-start">
                        <LogoTurismo className="w-full sm:w-full h-14 lg:w-[240px] lg:h-[70px]" />
                    </div>
                </nav>
            </header>
            <div className="mt-8 w-full flex justify-center">
                <div className="lg:w-[80%] lg:inline-flex smm:grid smm: grid-cols-2">
                    <div className="lg:w-[50%] smm:w-[100%]">
                        <div id="animation-carousel" className="relative w-full" data-carousel="static">
                            <div className="flex justify-center items-center relative h-[630px] overflow-hidden">
                                {images.map((src, index) => (
                                    <div
                                        key={index}
                                        className={`absolute block w-full transition-opacity duration-200 ease-linear ${index === activeIndex ? 'opacity-100' : 'opacity-0'}`}
                                        data-carousel-item
                                    >
                                        <img
                                            src={src}
                                            className="block w-full -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
                                            style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
                                            alt={`Slide ${index + 1}`}
                                        />
                                    </div>
                                ))}
                            </div>
                            <button
                                type="button"
                                className="absolute top-0 start-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
                                data-carousel-prev
                                onClick={handlePrev}
                            >
                                <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-primary-50/30 group-hover:bg-white/50 group-focus:ring-4 group-focus:ring-white dark:group-focus:ring-gray-800/70 group-focus:outline-none">
                                    <svg
                                        className="w-4 h-4 text-white dark:text-gray-800 rtl:rotate-180"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 6 10"
                                    >
                                        <path
                                            stroke="currentColor"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M5 1 1 5l4 4"
                                        />
                                    </svg>
                                    <span className="sr-only">Previous</span>
                                </span>
                            </button>
                            <button
                                type="button"
                                className="absolute top-0 end-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
                                data-carousel-next
                                onClick={handleNext}
                            >
                                <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-primary-50/30 group-hover:bg-white/50 group-focus:ring-4 group-focus:ring-white dark:group-focus:ring-gray-800/70 group-focus:outline-none">
                                    <svg
                                        className="w-4 h-4 text-white dark:text-gray-800 rtl:rotate-180"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 6 10"
                                    >
                                        <path
                                            stroke="currentColor"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="m1 9 4-4-4-4"
                                        />
                                    </svg>
                                    <span className="sr-only">Next</span>
                                </span>
                            </button>
                        </div>
                    </div>
                    {/**FORMULARIO */}
                    <div className="lg:w-[50%] smm:w-[100%] lg:h-[100%] smm:h-[70%] bg-secondary-300 rounded-r-xl block justify-center">
                        <div className="m-6">
                            <h1 className="font-bold text-primary-800 text-[45px] text-center mb-4">RESERVAR TOUR </h1>

                            <form onSubmit={handleSubmit}>
                                <div className="grid lg:grid-cols-2 gap-2 smm:grid-cols-1">
                                    <div className="mb-3 pt-3">
                                        <label className="mb-1 block text-base font-semibold text-primary-800 sm:text-xl">NOMBRE COMPLETO</label>
                                        <input
                                            className="mx-2 w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                                            type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} required />
                                    </div>
                                    <div className="mb-3 pt-3">
                                        <label className="mb-1 block text-base font-semibold text-primary-800 sm:text-xl">NUMERO DE CELULAR</label>
                                        <input
                                            className="mx-2 w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                                            type="text" id="phone" name="phone" value={formData.phone} onChange={handleChange} required />
                                    </div>
                                </div>

                                <div className="grid lg:grid-cols-2 gap-2 smm:grid-cols-1">
                                    <div className="mb-3 pt-3">
                                        <label className="mb-1 block text-base font-semibold text-primary-800 sm:text-xl">CORREO ELECTRONICO</label>
                                        <input
                                            className="mx-2 w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                                            type="email" name="email" value={formData.email} onChange={handleChange} required />
                                    </div>
                                    <div className="mb-3 pt-3">
                                        <label className="mb-1 block text-base font-semibold text-primary-800 sm:text-xl">SELECCIONE TOUR</label>
                                        <select
                                            className="mx-2 w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                                            name="package" value={formData.package} onChange={handleChange} required>
                                            <option value="">Selecciona una opción</option>
                                            <option value="Qoricancha">Qoricancha</option>
                                            <option value="Sacsayhuaman">Sacsayhuaman</option>
                                            <option value="Cristo Blanco">Cristo Blanco</option>
                                            <option value="Bosque de Árboles de Q'enqo">Bosque de Árboles de Q'enqo</option>
                                            <option value="Huayllarcocha">Huayllarcocha</option>
                                            <option value="Puca Pucara">Puca Pucara</option>
                                            <option value="Tambomachay">Tambomachay</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="grid lg:grid-cols-2 gap-2 smm:grid-cols-1">
                                    <div className="mb-3 pt-3">
                                        <label className="mb-1 block text-base font-semibold text-primary-800 sm:text-xl">NÚMERO DE PERSONAS</label>
                                        <input
                                            className="mx-2 w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                                            type="number" name="numberOfPeople" min="1" value={formData.numberOfPeople} onChange={handleChange} required />
                                    </div>
                                    <div className="mb-3 pt-3">
                                        <label className="mb-1 block text-base font-semibold text-primary-800 sm:text-xl">FECHA DE TOUR</label>
                                        <input
                                            className="mx-2 w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                                            type="date" name="tourDate" value={formData.tourDate} onChange={handleChange} required />
                                    </div>
                                </div>

                                <div className="grid lg:grid-cols-2 gap-2 smm:grid-cols-1">
                                    <div className="mb-3 pt-3">
                                        <label className="mb-1 block text-base font-semibold text-primary-800 sm:text-xl">MÉTODO DE PAGO</label>
                                        <select
                                            className="mx-2 w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                                            name="paymentMethod" value={formData.paymentMethod} onChange={handleChange} required>
                                            <option value="">Selecciona una opción</option>
                                            <option value="Billetera_digital">Billetera digital</option>
                                            <option value="Transferencia_bancaria">Transferencia Bancaria</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="w-full mt-4 inline-flex justify-center items-center">
                                <button className="m-4 font-bold border-2 border-primary-800 p-4 bg-primary-50 rounded-xl text-primary-800" 
                                type="submit">Reservar</button>
                            </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {showModal && (
                <ModalReservaTour
                    data={data}
                    onClose={handleIsCloseModal}
                />
            )}
        </>
    );
}
